import React, {useEffect, useState} from "react";
import InputForm from "../../../../components/input/input-form.jsx";
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import {FaCircleExclamation, FaTriangleExclamation} from "react-icons/fa6";

const ReviewItemsList = ({items, setItems, currentKm, disabled = false}) => {
  const handleChange = (id, field, value) => {
    setItems(prev =>
      prev.map(item =>
        item.description_id === id
          ? { ...item, [field]: value }
          : item
      )
    );
  };

  const itemForm = (item) => {
    const hasValidNextKm = item.next_km_revision !== null && item.next_km_revision !== "";

    const isOverdue = item.applyEffect && hasValidNextKm && currentKm > item.next_km_revision;
    const isWarning = item.applyEffect && hasValidNextKm && !isOverdue && (item.next_km_revision - currentKm) <= 2000;

    const statusColorClass = isOverdue ? "text-[#ed5565]!" : isWarning ? "text-[#f8ac59]!" : "";

    return (
      <li key={item.description_id}>
        <div className="flex gap-4 flex-wrap">
          <div className="flex-1 min-w-[120px]">
            <span className="font-bold">{item.description}</span>
          </div>
          <div className="flex-1 min-w-[90px]">
            <InputForm
              id={`km-${item.description_id}`}
              label="Km"
              integerOnly
              type="number"
              disabled={disabled}
              value={item.km}
              onChange={(e) =>
                handleChange(item.description_id, "km", e.target.value)
              }
            />
          </div>
          <div className="flex-1 min-w-[150px]">
            <InputDateTime
              id={`date-${item.description_id}`}
              label="Data"
              disabled={disabled}
              selected={item.date}
              onChange={(date) =>
                handleChange(item.description_id, "date", date)
              }
              dateFormat="L"
            />
          </div>
          <div className="flex-2 min-w-[220px]">
            <div className="relative">
              <InputForm
                id={`next_km_revision-${item.description_id}`}
                label={`Próximo km de ${item.description}`}
                integerOnly
                type="number"
                disabled={disabled}
                value={item.next_km_revision}
                labelClass={statusColorClass}
                inputClass={statusColorClass}
                onChange={(e) =>
                  handleChange(item.description_id, "next_km_revision", e.target.value)
                }
              />
              { isOverdue &&
                <FaTriangleExclamation title="Km de Revisão vencido" className="absolute top-2 right-3" size={16} color="#ed5565"/>
              }
              { isWarning &&
                <FaCircleExclamation title="Km de Revisão a vencer" className="absolute top-2 right-3" size={16} color="#f8ac59"/>
              }
            </div>
          </div>
          <div className="flex-3 min-w-[270px]">
            <InputDateTime
              id={`nextDate-${item.description_id}`}
              label={`Próxima data de ${item.description}`}
              disabled={disabled}
              selected={item.next_date_revision}
              onChange={(date) =>
                handleChange(item.description_id, "next_date_revision", date)
              }
              dateFormat="L"
            />
          </div>
        </div>
      </li>
    );
  };

  return(
    <ul className="flex flex-col gap-4">
      { items.length > 0 &&
        items.map(item => itemForm(item))
      }
    </ul>
  )
}

export default ReviewItemsList;